import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Style } from '@/components/style';
import { setWelcomeCustomerComment } from '@/actions/customizeWelcome/customizeWelcomeAction';
import OrderServeType from '@/constants/OrderServeType';
import { useDispatch } from 'react-redux';

const { gray3Color, blackColor } = new Style().getUiConfig();
function WelcomeComment({ webStoreVo, selectedServeType }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [comment, setComment] = useState('');
  const onChangeComment = (e) => {
    dispatch(setWelcomeCustomerComment(e.target.value));
    setComment(e.target.value);
  };
  return (
    <div style={{ marginBottom: '10px' }}>
      {selectedServeType === OrderServeType.DELIVERY &&
        webStoreVo?.webUiConfig?.showRequireComments && (
          <div className="d-flex flex-column justify-content-center">
            <textarea
              rows={3}
              style={{
                padding: '10px',
                width: '100%',
                fontSize: '18px',
                borderRadius: '10px',
              }}
              data-testid="comment"
              placeholder={intl.formatMessage({
                id: 'cart.customerInfo.order.comment',
              })}
              defaultValue={comment}
              onChange={onChangeComment}
              maxLength={1000}
            />
          </div>
        )}
    </div>
  );
}

WelcomeComment.propTypes = {
  webStoreVo: PropTypes.shape({}).isRequired,
  selectedServeType: PropTypes.string.isRequired,
};

export default WelcomeComment;
